module.exports = __webpack_public_path__ + "img/list-mark-option.76612898.svg";